export const getLanguage = (language) =>
  import(`./date.i18n/${language}.js`)